import contracts from "./contracts";
import files from "../files";
import forms from "./forms";

export const employment = {
    contracts,
    files,
    forms,
};

export default employment;
